module.exports = __webpack_public_path__ + "img/beijing.e6c20903.jpg";